<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tL61Si/tc-custom/9781504058704.jpg?1734322801871" alt="This image is the cover for the book Light Within Us"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Light Within Us
      </h1>
      <p class="bookDescription body article font2">
        <b>The classic collection of timeless quotations from the Nobel Peace Prize–winning missionary, theologian, and international bestselling author.</b><br/><br/> Famous for founding the Albert Schweitzer Hospital in Lambaréné, in what is now the West African country of Gabon, Albert Schweitzer was an accomplished theologian, physician, philosopher, music scholar, international bestselling author, and even a virtuoso organist. His many pursuits and achievements were inspired by his ethical philosophy of “Reverence for Life,” which he wrote about extensively in his many books and articles.<br/>  <br/> In <i>The Light Within Us</i>, Schweitzer’s longtime friend Richard Kik has compiled many of his most insightful and inspiring quotations. Drawn from his many writings, these quotations share Schweitzer’s thoughts on service, gratitude, God, missionary work, and much more. A wonderful introduction to the breadth of Schweitzer’s thought, this slim volume contains an abundance of wisdom.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Albert Schweitzer
      </h2>
      
      <p class="authorDescription body article">Albert Schweitzer, OM (14 January 1875 &ndash; 4 September 1965) was a German&mdash;and later French&mdash;theologian, organist, philosopher, physician, and medical missionary in Africa, also known for his interpretive life of Jesus. He was born in the province of Alsace-Lorraine, at that time part of the German Empire. He considered himself French and wrote in French. Schweitzer, a Lutheran, challenged both the secular view of Jesus as depicted by historical-critical methodology current at his time in certain academic circles, as well as the traditional Christian view.<BR /> &#160;<BR /> He received the 1952 Nobel Peace Prize for his philosophy of &ldquo;Reverence for Life&rdquo;, expressed in many ways, but most famously in founding and sustaining the Albert Schweitzer Hospital in Lambar&eacute;n&eacute;, now in Gabon, west central Africa (then French Equatorial Africa). As a music scholar and organist, he studied the music of German composer Johann Sebastian Bach and influenced the Organ reform movement (Orgelbewegung).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a5fe777